<template>
  <component
    :is="notLink ? 'div' : nuxtLinkComponent"
    :to="url"
    :target="newTab ? `_blank` : '_self'"
    class="link text_a body-l-medium"
  >
    <span v-if="mobileTitle" class="text" :style="{ color }">
      <span class="text-mobile">{{ mobileTitle ? mobileTitle : title }}</span>
      <span class="text-tablet">{{ title }}</span>
    </span>
    <span v-else class="text" :style="{ color }">{{ title }}</span>
    <span class="slider_triangle__wrapper">
      <span class="slider_triangle slider_triangle--right">
        <span
          class="slider_triangle__elem"
          :style="{ backgroundColor: color }"
        />
      </span>
    </span>
  </component>
</template>

<script lang="ts" setup>
defineProps({
  url: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: 'Ссылка',
  },
  mobileTitle: {
    type: String,
    default: '',
  },
  color: {
    type: String,
  },
  notLink: Boolean,
  newTab: {
    type: Boolean,
    default: false,
  },
});
const nuxtLinkComponent = shallowRef(defineNuxtLink({}));
</script>
<style lang="scss" scoped src="./link-triangle.scss"></style>
